export const THEME_DESCRIPTION_KEYS: Record<string, string> = {
  recommended: 'theme.recommended_description',
  creamy: 'theme.artisan_description',
  contemporary: 'theme.structure_description',
  mature: 'theme.oasis_description',
  nostalgic: 'theme.landmark_description',
  technical: 'theme.professional_description',
};

export const THEME_NAME_KEYS: Record<string, string> = {
  recommended: 'theme.recommended',
  creamy: 'theme.artisan',
  contemporary: 'theme.structure',
  mature: 'theme.oasis',
  nostalgic: 'theme.landmark',
  technical: 'theme.professional',
};
